export const readFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key)) || [];
};

export const writeToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify([...new Set(data)]));
};
